export const REPORTING_LINE_SETUP_PATH = "/settings/reporting-line";
